// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExpandAltOutlinedSvg from "@fishx/icons-svg/es/asn/ExpandAltOutlined";
import FishxIcon from '../components/FishxIcon';

var ExpandAltOutlined = function ExpandAltOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExpandAltOutlinedSvg
  }));
};

ExpandAltOutlined.displayName = 'ExpandAltOutlined';
export default React.forwardRef(ExpandAltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExpandAltOutlined.js
// module id = 2640
// module chunks = 0